export default {
  SITE_TITLE: 'Auth0 Lab Docs',
  PAGE_NOT_FOUND: "We couldn't find the page you were looking for.",
  ERROR_PROCESSING_REQUEST: 'There was an error processing your request.',
};
